'use client';

import { styled } from '@linaria/react';
import Image from 'next/image';
import Link from 'next/link';
import { GTM_EVENT_POP_TOPIC_CAROUSEL } from '@fe-news/constants/pop-topic/type';
import { GaActionType, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.55px;
  text-align: justify;
  color: #000;
  margin-bottom: 16px;

  span {
    flex: 1;
    margin-left: 8px;
  }
`;

const ReadMore = styled(Link)`
  display: flex;
  font-size: 13px;
  letter-spacing: 0.5px;
  color: #e03f19;
  align-items: center;

  img {
    margin-left: 4px;
  }
`;

type SubTitleProps = {
  imageUrl: string;
  title: string;
  isNeedReadMore?: boolean;
  readMoreLink?: string;
  isCarousel?: boolean;
  gtmEvent?: GaActionType;
};

const SubTitle: React.FC<SubTitleProps> = ({
  imageUrl,
  title,
  isNeedReadMore = true,
  readMoreLink = '/poptopic',
  isCarousel = false,
  gtmEvent
}) => {
  const onClickReadMore = () => {
    if (gtmEvent) return sendGTM(gtmEvent);
    sendGTM({
      ...GTM_EVENT_POP_TOPIC_CAROUSEL,
      [GTMEventKey.CLICK_ITEM]: isCarousel ? '置頂時事_看更多' : '看更多'
    });
  };

  return (
    <Title>
      <Image src={imageUrl} alt={title} width={26} height={26} unoptimized />
      <span>{title}</span>
      {isNeedReadMore && (
        <ReadMore href={`${readMoreLink}`} onClick={onClickReadMore} prefetch={false}>
          看更多
          <Image src='/assets/icons/arrows/icon-arrow-right-red.png' alt='Next' width={7} height={10} />
        </ReadMore>
      )}
    </Title>
  );
};

export default SubTitle;
